import type { GUIProps } from "@scratch/scratch-gui/standalone";

export const createStandaloneEditorProps = (
    overrides: GUIProps = {},
): GUIProps => ({
    backpackVisible: false,
    canChangeLanguage: false,
    canEditTitle: false,
    canManageFiles: false,
    canSave: false,
    showDebugButton: false,
    showComingSoon: false,
    showTelemetryModal: false,
    showTutorialsButton: false,
    ...overrides,
});
